const nodeRedActions = {
  redirect: 'redirect_url',
  thankYou: 'thank_you_msg',
};

export default nodeRedActions;
